import * as React from 'react';
import { Price } from './Price';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalData } from '../../../../../../selectors/buyPackageModal';

export const PriceContainer = () => {
  const data = useSelector(selectBuyPackageModalData);

  const { marketingPrice, discountPercent, price } = data;

  return <Price discountPercent={discountPercent} marketingPrice={marketingPrice} total={price} />;
};
